export enum MenuPosition {
    TOP_BAR = 'TopBar',
    FOOTER = 'Footer',
    SIDEBAR = 'Sidebar',
}
